import { useCallback, useRef, useState } from "react";


import useLoadScript from "app/hooks/useLoadScript";
import Button from "app/components/Button";
import { ReactComponent as GoogleSocial } from "app/assets/icons/google-social.svg";
import tw from "twin.macro";
import { GOOGLE_CLIENT_ID } from "app/constants/variables";


interface Props {
  onAuthenticated?: (v: google.accounts.id.CredentialResponse) => void;
  loading?: boolean;
}
export default function GoogleAuth({ onAuthenticated, loading }: Props) {
  const [googleAuthLoaded, setGoogleAuthLoaded] = useState(false);

  const googleButtonDiv = useRef<HTMLDivElement>(null);

  useLoadScript({
    url: "https://accounts.google.com/gsi/client",
    onLoad: useCallback(() => {
      setGoogleAuthLoaded(true);

      const googleObj = window.google;
      if (!googleObj) return;

      const googleAccounts = googleObj.accounts;

      const container = googleButtonDiv.current;
      if (!container) return;

      googleAccounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID || "",
        callback: onAuthenticated,
        use_fedcm_for_prompt: true,
      });

      googleAccounts.id.prompt();

      googleAccounts.id.renderButton(container, {
        type: "standard",
        theme: "outline",
        shape: "rectangular",
        width: 400,
        size: "large",
        logo_alignment: "center",
      });
    }, [onAuthenticated]),
    cleanup: useCallback(() => {
      if (window.google) {
        window.google.accounts.id.cancel();
      }
    }, []),
  });

  return (
    <div tw="relative">
      <Button
        type="button"
        variant="secondary"
        size="xBig"
        css={[tw`w-full hidden`, googleAuthLoaded && tw`flex`]}
        loading={loading}
        icon={<GoogleSocial tw="w-[24px] h-[24px]" />}
      >
        Continue with Google
      </Button>

      <div
        ref={googleButtonDiv}
        tw="overflow-hidden opacity-[0.001] cursor-pointer absolute inset-0 [&>div]:h-full [&_iframe]:!w-full [&_iframe]:!m-0 [&_iframe]:scale-[1.6]"
      ></div>
    </div>
  );
}
